/* eslint-disable */

export default {
    api: "https://map.stacksgpt.xyz/nodes"
}
